export class DocumentHistoryResModel {
  OrderId: number;
  ServiceType: string;
  AdmissionNo: string;
  IsDocument: boolean;
  IsHistory: boolean;
  IsCheck: boolean;
}
